module.exports = __webpack_public_path__ + "static/media/amazon-account.1e736ebd.svg";